import styled from "styled-components"

export const Button = styled.button<any>`
  background: var(--primary);
  border: 0;
  color: var(--background);
  font-weight: bold;
  font-size: 14px;
  padding: 10px 20px;
  text-transform: uppercase;
  cursor: pointer;
`
